import Alert from '@mui/material/Alert'
import Box from '@mui/material/Box'
import { AutoEligibilityTimeRetrieveResponse } from '@fireflyhealth/api'
import { formatDateWithDay } from '~/shared/lib/date'

interface IProps {
  responseData: AutoEligibilityTimeRetrieveResponse
}

const EligibilityCheckResponseDetails = (props: IProps) => {
  if (!props.responseData) return null

  const { is_eligible, rejections, requested_by_user, latest_response_time } = props.responseData
  const requesterDescription = requested_by_user?.first_name
    ? `Requested by ${requested_by_user.first_name} ${requested_by_user.last_name}`
    : ''
  const formattedTime = latest_response_time
    ? formatDateWithDay(new Date(latest_response_time))
    : null

  if (is_eligible) {
    return (
      <Alert severity="success">
        <Box sx={{ display: 'block' }}>
          <strong>Eligible</strong> - Checked on {formattedTime}
          {requesterDescription && <div>{requesterDescription}</div>}
        </Box>
      </Alert>
    )
  }

  if (rejections) {
    return (
      <Alert severity="warning">
        <Box sx={{ display: 'block' }}>
          <strong>{rejections.join(',')}</strong> - Checked on&nbsp;
          {formattedTime}
        </Box>
      </Alert>
    )
  }

  return (
    <Alert severity="error">
      <Box sx={{ display: 'block' }}>
        <strong>Ineligible</strong> - Checked on {formattedTime}
        {requesterDescription && <div>{requesterDescription}</div>}
      </Box>
    </Alert>
  )
}

export default EligibilityCheckResponseDetails
